export interface AllocationSection {
  id?: string;
  name: string;
  configurations: AllocationConfiguration[];
}

export interface AllocationStats {
  totalActiveAllocations: number;
  allocationsExpiringToday: number;
}

export interface CiuAllocationsState {
  configurationSections: AllocationSection[] | null;
  formSections: any[] | null;
  selectedConfigurationId: string | null;
  editConfigurationData: ConfigurationFormData | null;
  allocationStats: AllocationStats | null;
  isDrawerLoading: boolean;
  isTableLoading: boolean;
  isStatsLoading: boolean;
  error: string | null;
  pagination: {
    pageIndex: number;
    pageSize: number;
    totalElements: number;
  };
}

export interface AllocationConfiguration {
  id?: string;
  allocationTeam: string;
  allocationPurpose: string;
  caseDpdBucket: string;
  caseTeam: string;
  caseExpiry: number;
  allocationDates: string;
  dpdExclusion: string;
  emiOverdue?: string | number;
  emiAmount?: string | number;
  lastMonthCollection?: string | number;
  currentMonthCollection?: string | number;
  posAmount?: string | number;
  currentMonthCosmosNcFeedback?: string;
  currentMonthCosmosNcFeedbackDays?: string | number;
  currentMonthLonghornNcFeedback?: string;
  currentMonthLonghornNcFeedbackDays?: string | number;
  lastMonthCosmosNcFeedback?: string;
  lastMonthLonghornNcFeedback?: string;
  numberOfCases?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ConfigurationFormProps {
  isDrawerOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  setIsSubmitButtonDisabled: (disabled: boolean) => void;
  setIsDirtyField?: (dirty: boolean) => void;
  configurationData?: ConfigurationFormData;
}

export interface AddConfigurationDrawerProps {
  isDrawerOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  handleQueryCopy: (formData?: ConfigurationFormData) => void;
  configurationData?: ConfigurationFormData;
}

export interface EditConfigurationDrawerProps {
  isDrawerOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  handleQueryCopy: () => void;
}

export interface ConfigurationFormData {
  allocationTeam: string;
  allocationPurpose: string;
  caseDpdBucket: string;
  caseTeam: string;
  caseExpiry: number | string;
  allocationDates: string;
  dpdExclusion: string;
  emiOverdue?: string | number;
  emiAmount?: string | number;
  lastMonthCollection?: string | number;
  currentMonthCollection?: string | number;
  posAmount?: string | number;
  currentMonthCosmosNcFeedback?: string | string[];
  currentMonthCosmosNcFeedbackDays?: string | number;
  currentMonthLonghornNcFeedback?: string | string[];
  currentMonthLonghornNcFeedbackDays?: string | number;
  lastMonthCosmosNcFeedback?: string | string[];
  lastMonthLonghornNcFeedback?: string | string[];
}

export interface GetLatestConfigResponse {
  version: number;
  questionnaire: {
    sections: Array<{
      id: string;
      label?: string;
      questions: Array<{
        id: string;
        label: string;
        mandatory: boolean;
        options: string[];
      }>;
    }>;
  };
}

export interface GetConfigByIdResponse {
  configId: string;
  version: number;
  questionnaire: {
    sections: Array<{
      id: string;
      label?: string;
      questions: Array<{
        id: string;
        label: string;
        mandatory: boolean;
        options: string[];
        answer?: any;
      }>;
    }>;
  };
}

export interface GetAllConfigsResponse {
  content: Array<{
    id: string;
    allocationTeam: string;
    allocationPurpose: string;
    dpdBucket: string;
    caseTeam: string;
    caseExpiryDays: number;
    allocationDates: number[];
    dpdExclusions: string[];
    casesQuery: string;
  }>;
  pageable: {
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    offset: number;
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    unpaged: boolean;
  };
  last: boolean;
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  first: boolean;
  numberOfElements: number;
  empty: boolean;
}

export interface AllocationData {
  id: string;
  allocationTeam: string;
  allocationPurpose: string;
  caseExpiryDays: string;
  caseTeam: string;
  allocationDates: Array<number>;
  dpdExclusions: Array<string>;
  dpdBucket: string;
  casesQuery: string;
}

export interface CreateConfigPayload {
  usecaseId: string;
  version: number;
  answers: {
    [key: string]: any;
  };
}

export interface ValidationResult {
  isValid: boolean;
  errors: boolean[];
  errorMessage: string;
}

export enum DPDRangeField {
  From = 'from',
  To = 'to'
}

export type RangeInput = Record<DPDRangeField, string>;

export interface ParsedRange {
  from: number;
  to: number;
  originalIndex: number;
  isValid: boolean;
}
